import React, {ReactElement, useCallback, useEffect, useState} from "react";

import styles from "./toast.module.scss";

export interface ToastItem {
	description: string;
	type: "success" | "failure" | "informational";
}

export interface ToastProps {
	toastItem?: ToastItem;
	position: "top" | "bottom";
}

export const Toast = (props: ToastProps): ReactElement => {
	const {toastItem, position} = props;
	const [toast, setToast] = useState<ToastItem | undefined>(toastItem);

	useEffect(() => {
		setToast(toastItem);
	}, [toastItem]);

	useEffect(() => {
		let interval: NodeJS.Timeout;
		if (toast) {
			interval = setInterval(() => {
				setToast(undefined);
			}, 2500);
		}
		return () => clearInterval(interval);
	}, [toast]);

	const getStyle = useCallback(() => {
		if (toast) {
			if (toast.type === "failure") return styles.failure;
			if (toast.type === "informational") return styles.info;
			return styles.success;
		}
	}, [toast?.type]);
	return (
		<div
			className={[styles.container, styles[position]].join(" ")}
		>
			{toast && <p
				className={[getStyle(), styles.toast, styles[position]].join(" ")}>
				{toast.description}
			</p>
			}
		</div>
	);
};
